const sleep = (duration) => {
  return new Promise((resolve) => setTimeout(resolve, duration));
};

const removeKeysWithNullValues = (obj) => {
  const asArray = Object.entries(obj);
  const filtered = asArray.filter(([key, value]) => value !== null);
  return Object.fromEntries(filtered);
};

const toTitleCase = (str) => {
  return str
    .split(" ")
    .map((w) => w[0].toUpperCase() + w.substring(1).toLowerCase())
    .join(" ");
};

export { sleep, removeKeysWithNullValues, toTitleCase };
